import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { DownloadSimple } from "@phosphor-icons/react";

export default function StaffPayslips() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    Promise.all([
      api.get("/payroll").then((r) => r.data.map((x) => ({ ...x, _source: "auto" }))).catch(() => []),
      api.get("/manual-payroll").then((r) => r.data.map((x) => ({
        id: x.id, month: x.month, year: x.year, _source: "manual",
        present_days: x.calculation?.present_days, late_minutes: x.calculation?.overtime_hours,
        net_salary: x.calculation?.net_salary, status: x.status,
      }))).catch(() => []),
    ]).then(([a, b]) => {
      const merged = [...b, ...a].sort((x, y) => (y.year - x.year) || (y.month - x.month));
      setRows(merged);
    });
  }, []);
  return (
    <div className="px-5 pt-6 pb-12 max-w-md mx-auto">
      <p className="text-xs tracking-[0.3em] uppercase text-[#E50914]">Earnings</p>
      <h1 className="font-display text-3xl tracking-tight">My Payslips</h1>
      <div className="mt-5 space-y-3" data-testid="staff-payslips-list">
        {rows.map((r) => (
          <div key={`${r._source}-${r.id}`} className="bg-[#16161C] border border-[#2D2D35] rounded-md p-4">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm">{String(r.month).padStart(2,"0")} / {r.year}</div>
                <div className="text-[10px] text-zinc-500 font-mono mt-1 inline-flex items-center gap-2">
                  <span className="px-1.5 py-0.5 rounded bg-[#0D0D10] border border-[#2D2D35]">
                    {r._source === "manual" ? "MANUAL" : "AUTO"}
                  </span>
                  {r.status && <span>· {r.status}</span>}
                </div>
              </div>
              <div className="text-right">
                <div className="font-mono text-xl text-[#E50914]">₹ {Number(r.net_salary).toLocaleString()}</div>
                <a
                  href={r._source === "manual" ? `${API}/manual-payroll/${r.id}/pdf` : `${API}/payroll/${r.id}/pdf`}
                  target="_blank" rel="noreferrer"
                  className="text-xs text-zinc-400 inline-flex items-center gap-1 mt-1 hover:text-[#E50914]"
                  data-testid={`pdf-${r.id}`}>
                  <DownloadSimple size={12} /> PDF
                </a>
              </div>
            </div>
          </div>
        ))}
        {!rows.length && <div className="text-sm text-zinc-500 text-center py-8">No payslips generated yet.</div>}
      </div>
    </div>
  );
}

